<!-- USED FOR BASIC MODALS -->


<template style="display: flex; justify-content: center; align-items: center;">
  <div id="modal-wrapper" v-if="modalVisible">
    <div id="basic-modal" class="FCNW">
      <div class="title-bar">
        <div 
          @click="hideModal" 
          id="hide-modal-btn"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
          </svg>
        </div>
      </div>

      <div id="modal-header">
        <h3>{{ modalHeader }}</h3>
      </div>

      <div id="modal-message">
        {{ modalMessage }}
      </div>

      <div id="modal-ok-wrapper">
        <ModernButtonVue
          :btnText="'OK'"
          :clickFunc=" okBtnFunc || hideModal "
          :btnSize="'small'"
          :showBorder="true"
        />
      </div>
    </div>
  </div>
</template>


<script>
import ModernButtonVue from './ModernButton.vue';

export default {
  name: 'BasicModal',
  components: {
    ModernButtonVue,
  },
  props: {
    okBtnFunc: Function,
  },
  data() {
    return {
      modalHeader: String,
      modalMessage: String,
      modalVisible: false,
    }
  },
  computed: {},
  methods: {
    showModal( { modalHeader, modalMessage }, hideBackdrop=false ) {
      
      if ( !modalHeader && !modalMessage ) return;

      if ( !hideBackdrop ) window.ShowBackdrop( true );

      this.modalVisible = true;
      this.modalHeader = modalHeader;
      this.modalMessage = modalMessage;
    },

    hideModal() {
      window.HideBackdrop( true );
      this.modalVisible = false;
      this.modalHeader = '';
      this.modalMessage = '';
    }
  },
  mounted() {
    window.ShowModal = this.showModal;
    window.HideModal = this.hideModal;
  }
}

</script>


<style scoped>

#modal-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 55;
}



#basic-modal {
  display: flex;
  padding: .5rem;
  background-color: gainsboro;
  z-index: 55;
  border-radius: 10px;
  min-width: 50%;
  border: 2px solid black;
}

#hide-modal-btn {
  cursor: pointer;
  padding: .3rem;
  display: flex;
  border-radius: 5px;
  transition: all .3s;
}
#hide-modal-btn:hover {
  background-color: rgb(241, 162, 162);
}

.title-bar {
  display: flex;
  flex-direction: row-reverse;
}

.title-bar div {
  cursor: pointer;
}

#modal-message, #modal-ok-wrapper {
  margin: 1rem;
}

</style>